__turbopack_context__.v({
  "allCard": "category-card-module-scss-module__XH1rza__allCard",
  "allIcon": "category-card-module-scss-module__XH1rza__allIcon",
  "body": "category-card-module-scss-module__XH1rza__body",
  "card": "category-card-module-scss-module__XH1rza__card",
  "count": "category-card-module-scss-module__XH1rza__count",
  "go": "category-card-module-scss-module__XH1rza__go",
  "iconTile": "category-card-module-scss-module__XH1rza__iconTile",
  "name": "category-card-module-scss-module__XH1rza__name",
});
